import axios from "axios";
import { Dispatch } from "redux";
import { baseURL } from "../globals/constants";
import { setUserInfo, setUserToken } from "../redux/slices/AuthenticationSlice";
import { ForgetPasswordValues, ResetPasswordValues } from "../utils/forms";
import { showErrorToast } from "../utils/Toast";

interface LoginFormValues {
    email: string;
    password: string;
}

export const loginUser = async (
    values: LoginFormValues,
    dispatch:Dispatch,
    isMobile:boolean
) => {
    try {
        const response: any = await axios.post(
            `${baseURL}/v1/auth/login`,
            {
                email: values.email,
                password: values.password,
            },
            {
                withCredentials: true,
            }
        );
        // Admins get a two-step challenge instead of tokens (see SignIn: code or 2FA set-up)
        if (response?.data?.challengeToken) {
            return response;
        }
        storeSession(response.data, dispatch);
        return response;
    } catch (error: any) {
        const message = error?.response?.data?.message || "An error occurred during login";
        showErrorToast(message, isMobile)
    }
};

/** Keeps the signed-in admin's session (the refresh token lets sessionRefresh renew it) */
export const storeSession = (data: any, dispatch: Dispatch) => {
    localStorage.setItem("access_token", data.tokens.access.token);
    localStorage.setItem("refresh_token", data.tokens.refresh.token);
    localStorage.setItem("user", JSON.stringify(data.user));
    localStorage.setItem("role", JSON.stringify(data.user?.role));
    dispatch(setUserInfo(data.user));
    dispatch(setUserToken(data.tokens));
};

const twoFactorCall = async (path: string, body: Record<string, string>, isMobile: boolean) => {
    try {
        const response = await axios.post(`${baseURL}/v1/auth/2fa/${path}`, body);
        return response.data;
    } catch (error: any) {
        showErrorToast(error?.response?.data?.message || "Two-step verification failed", isMobile);
        return null;
    }
};

/** Step 2 of the admin login: code from the authenticator app or a backup code */
export const verifyTwoFactor = async (challengeToken: string, code: string, dispatch: Dispatch, isMobile: boolean) => {
    const data = await twoFactorCall("verify", { challengeToken, code }, isMobile);
    if (data) storeSession(data, dispatch);
    return data;
};

/** First admin login: QR code for the authenticator app */
export const setupTwoFactor = (challengeToken: string, isMobile: boolean) =>
    twoFactorCall("setup", { challengeToken }, isMobile) as Promise<{ secret: string; otpauthUrl: string; qrDataUrl: string } | null>;

/** First admin login: confirm with a code; returns the backup codes (shown once) */
export const enableTwoFactor = async (challengeToken: string, code: string, dispatch: Dispatch, isMobile: boolean) => {
    const data = await twoFactorCall("enable", { challengeToken, code }, isMobile);
    if (data) storeSession(data, dispatch);
    return data as { backupCodes: string[] } | null;
};

export const forgetPassword=async(
    values:ForgetPasswordValues,
    isMobile:boolean
)=>{
    try {
      
        const response=await axios.post(
            `${ baseURL }/v1/auth/forgot-password`,
            {
                email:values.email
            },
            {
                withCredentials:true
            }
        );
        return response;
    } catch (error:any) {
        const message = error?.response?.data?.message || "An error occurred while requesting forget password";
        showErrorToast(message, isMobile)
    }
}


export const resetPassword = async (
    values: ResetPasswordValues,
    isMobile:boolean
) => {
    try {
        const token = localStorage.getItem("token");
        const response = await axios.post(
            `${baseURL}/v1/auth/reset-password?token=${token}`,
            {
                password: values.newPassword
            },
            {
                withCredentials: true
            }
        );
        console.log("response in auth  ", response)
        return response;
    } catch (error:any) {
        const message = error?.response?.data?.message || "An error occurred while requesting reset password";
        showErrorToast(message, isMobile)
    }
}


export interface User {
    firstName: string;
    lastName: string;
    email: string;
    phoneNumber: string;
    password: string;
}

export const signupUser = async(data: User) => {
    try{
        console.log("Base url: ", baseURL);
        
        const response: any = axios.post(`${baseURL}/v1/auth/registerAdmin`, data);
        return response.data;
    }
    catch(err){
        console.log("Error signing up");
        throw err;
    }
} 

